module.exports = ".card-type {\r\n  font-size: 20px;\r\n  margin-left: 7px;\r\n}\r\n\r\n.cc-billing {\r\n  margin-right: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/member-billing-info/payment-type/payment-type.component.css
// module id = ./src/app/shared/components/member-billing-info/payment-type/payment-type.component.css
// module chunks = main